import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { AUTH_HEADER_KEY, setAuthTokenByHttpHeaders, getAuthToken, getAuthTokenAndPrefix } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class AuthInterceptor implements HttpInterceptor {

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (request && !request.headers.has(AUTH_HEADER_KEY)) {
      const token = this.getToken();
      if (token) {
        request = request.clone({
          setHeaders: {
            [AUTH_HEADER_KEY]: token
          }
        });
      }
    }

    return next
      .handle(request)
      .pipe(
        tap(event => {
          if (event instanceof HttpResponse) {
            setAuthTokenByHttpHeaders(event.headers);
          }
        }));
  }

  private getToken(): string {
    const token = getAuthToken();
    return token && getAuthTokenAndPrefix(token);
  }
}   
